module.exports = __webpack_public_path__ + "img/roles_3.aeb0e03c.png";